import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Lottie from 'react-lottie';
import { IoShieldCheckmark, IoSpeedometerOutline } from 'react-icons/io5';
import { LiaStickyNoteSolid } from 'react-icons/lia';
import { MdGroups2 } from 'react-icons/md';
import { BiSolidBadgeCheck } from 'react-icons/bi';
import { useHistory } from 'react-router-dom';
import gs from '../../global.css';
import s from './style.css';
import { premiumAnimation } from '../../../assets/lottie';
import { colors } from '../../foundations';
import { iap } from '../../actions';
import { Button, CloudVaultIcon } from '../../components';
import { unixToDate } from '../../utils';
const data = [
    {
        title: 'Bigger CloudVault space',
        icon: React.createElement(CloudVaultIcon, null),
        basic: '1 GB',
        premium: '2 TB (2000 GB)',
        vault: true,
    },
    {
        title: 'Bigger file uploads',
        icon: React.createElement(IoSpeedometerOutline, { size: 28, color: colors.black }),
        basic: '50 MB',
        premium: '50 GB',
    },
    {
        title: 'End-to-end encrypted notes',
        icon: React.createElement(LiaStickyNoteSolid, { size: 28, color: colors.black }),
        basic: '50 notes',
        premium: '5000 notes',
    },
    {
        title: 'Higher Group Limit',
        icon: React.createElement(MdGroups2, { size: 28, color: colors.black }),
        basic: '10 members',
        premium: '250 members',
    },
    {
        title: 'Profile Badge',
        icon: React.createElement(BiSolidBadgeCheck, { size: 28, color: colors.primary }),
        basic: 'n/a',
        premium: 'Premium badge',
    },
];
const PremiumScreen = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'Sticknet | Premium';
        if (props.user)
            props.fetchSubscriptionDetails();
    }, []);
    const history = useHistory();
    const isDesktop = window.innerWidth > window.innerHeight;
    return (React.createElement("div", { className: gs.main },
        React.createElement("div", { className: `${gs.screenContainer} ${gs.centerScreen}` },
            React.createElement("div", { className: gs.box, style: { padding: '2vw 5vw' } },
                React.createElement(Lottie, { options: {
                        loop: true,
                        animationData: premiumAnimation,
                    }, height: 100, width: 100, isStopped: false, isPaused: false }),
                React.createElement("p", { className: s.sticknet },
                    "Sticknet ",
                    React.createElement("span", { className: s.premium }, "Premium")),
                React.createElement("div", { className: s.shieldText, style: { marginTop: 16 } },
                    React.createElement(IoShieldCheckmark, { color: '#34A853', size: 20, style: { marginRight: 8 } }),
                    "End-to-end encrypted"),
                React.createElement("div", { className: s.shieldText, style: { marginBottom: 12 } },
                    React.createElement(IoShieldCheckmark, { color: '#34A853', size: 20, style: { marginRight: 8 } }),
                    "Decentralized storage"),
                props.expiring && (React.createElement(React.Fragment, null,
                    React.createElement("p", { style: { marginTop: '12px' } },
                        "Current subscription expires on: ",
                        unixToDate(props.expires),
                        "."),
                    React.createElement("p", { style: { marginTop: '4px' } }, "Renew now to keep your premium benefits!"))),
                props.isBasic || props.expiring ? (React.createElement(React.Fragment, null,
                    React.createElement("p", { style: { fontWeight: 'bold', marginTop: 12 } }, "USD 8.99 / month"),
                    props.expiring ? (React.createElement(Button, { text: 'Proceed to checkout', colored: true, onClick: () => props.checkout() })) : (React.createElement(Button, { text: props.user
                            ? 'Try free for 30 days • Proceed to checkout'
                            : 'Try free for 30 days', colored: true, onClick: () => props.user
                            ? props.checkout()
                            : isDesktop
                                ? history.replace('/portal-login')
                                : history.replace('qr-redirect') })))) : null,
                data.map((item, index) => (React.createElement("div", { className: s.itemContainer, key: index, style: { marginTop: index === 0 ? '28px' : 0 } },
                    React.createElement("div", { className: s.titleContainer },
                        item.icon,
                        React.createElement("p", { style: { fontWeight: 'bold' } }, item.title)),
                    React.createElement("div", { className: s.textContainer },
                        React.createElement("p", { className: s.basicText },
                            "Basic: ",
                            item.basic),
                        React.createElement("p", { className: s.premiumText },
                            "Premium: ",
                            item.premium))))),
                !props.isBasic && !props.expiring ? (props.platform === 'web' ? (React.createElement("button", { type: 'button', className: s.cancel, onClick: () => {
                        if (!props.loading)
                            props.billingPortal();
                    } }, !props.loading ? 'Manage subscription' : 'Redirecting...')) : (React.createElement("p", null,
                    "Your subscription is billed through ",
                    props.platform === 'ios' ? 'Apple' : 'Google'))) : null))));
};
const mapStateToProps = (state) => ({
    isBasic: !state.auth.user || state.auth.user.subscription === 'basic',
    platform: state.app.subscription.platform,
    expiring: state.auth.user?.subscriptionExpiring,
    expires: state.app.subscription.expires,
    loading: state.progress.loading,
    user: state.auth.user,
});
const connector = connect(mapStateToProps, { ...iap });
export default connector(PremiumScreen);
